import { supabase } from '../lib/supabaseClient';

// ডাইনামিক CRUD জেনারেটর (কোড ছোট করার জন্য)
const createAPI = (tableName) => ({
  getAll: async () => {
    const { data, error } = await supabase.from(tableName).select('*').order('created_at', { ascending: false });
    if (error) throw error;
    return { data };
  },
  create: async (data) => {
    const { data: res, error } = await supabase.from(tableName).insert([data]).select();
    if (error) throw error;
    return { data: res[0] };
  },
  update: async (id, data) => {
    const { data: res, error } = await supabase.from(tableName).update(data).eq('id', id).select();
    if (error) throw error;
    return { data: res[0] };
  },
  delete: async (id) => {
    const { error } = await supabase.from(tableName).delete().eq('id', id);
    if (error) throw error;
  },
  // ব্যাকআপ নাম (যদি অ্যাপ অন্য নামে ডাকে)
  [`delete${tableName.slice(0,-1)}`]: async (id) => {
    const { error } = await supabase.from(tableName).delete().eq('id', id);
    if (error) throw error;
  }
});

export const authAPI = {
  login: async ({ email, password }) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw { response: { data: { detail: error.message } } };
    return { data: { token: data.session.access_token, user: data.user } };
  },
  register: async ({ name, email, password }) => {
    const { data, error } = await supabase.auth.signUp({ email, password, options: { data: { name } } });
    if (error) throw { response: { data: { detail: error.message } } };
    return { data: { token: data.session?.access_token, user: data.user } };
  },
  getMe: async () => {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error || !user) throw { response: { data: { detail: 'Unauthorized' } } };
    return { data: user };
  },
};

export const usersAPI = {
  getAll: async () => {
    const { data, error } = await supabase.from('profiles').select('*').order('created_at', { ascending: false });
    if (error) throw error;
    return { data };
  },
  updateRole: async (userId, role) => {
    const { data, error } = await supabase.from('profiles').update({ role }).eq('id', userId).select();
    if (error) throw error;
    return { data: data[0] };
  }
};

// সব মডিউলের জন্য এপিআই এক্সপোর্ট
export const promptsAPI = createAPI('prompts');
export const booksAPI = createAPI('books');
export const videosAPI = createAPI('videos');
export const packagesAPI = createAPI('packages');
export const promoCodesAPI = createAPI('promo_codes');

export const paymentsAPI = {
  ...createAPI('payments'),
  getAll: async () => {
    const { data, error } = await supabase.from('payments').select('*, profiles(email)').order('created_at', { ascending: false });
    if (error) throw error;
    return { data };
  }
};

export const subscriptionsAPI = {
  getByUser: async (userId) => {
    const { data, error } = await supabase.from('subscriptions').select('*, packages(*)').eq('user_id', userId).eq('status', 'active').maybeSingle();
    if (error) throw error;
    return { data };
  }
};
